import {
  CartAndDeliveryDatesDataProvider,
  CartCheckoutClient,
} from '@app/data/clients/cartCheckoutClient';
import { RedbubbleLayout } from '@redbubble/next/app';
import { RBLayoutProps } from '@redbubble/next/types';
import {
  RSPageType,
  useRSPageView,
} from '@redbubble/next-provider/rudderstack';
import CartPage from './CartPage';
import { DD_CHECKOUT_ERROR_METRIC_NAME } from './constants';

export { getServerSideProps } from './serverSideProps';

const cartCheckoutClient = new CartCheckoutClient({
  logging: {
    metricName: DD_CHECKOUT_ERROR_METRIC_NAME,
    context: 'CartPage',
  },
});

export default function CartPageContainer() {
  useRSPageView(RSPageType.Cart);
  return (
    <CartAndDeliveryDatesDataProvider client={cartCheckoutClient}>
      <CartPage />
    </CartAndDeliveryDatesDataProvider>
  );
}

CartPageContainer.layout = (props: RBLayoutProps) =>
  RedbubbleLayout({
    ...props,
    forceMobileHeader: true,
    disableExpandedMobileSearch: true,
    disableStickySearch: true,
    hideProductNavigation: true,
  });
